<template>
    <div class="arrow">
        <div
            class="arrow-body"
            :style="{color: color.primary}"
        >
            <p class='arrow-text'>{{ value }}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'GamificationArrow',

    props: {
        value: String,
        color: {
            type: Object,
            required: true,
        },
    },
};
</script>    
<style scoped>
    .arrow {
        position: relative;
        width: 200px;
        height: 50px;
        background-color: #EBEBEB;
        color: #000;
        font-weight: bold;
    }

    .arrow-body {
        height: 100%;
        padding: 12px 10px 10px 30px;
        text-align: center;
    }

    .arrow-text {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
    }

    .arrow::after {
        content: '';
        position: absolute;
        bottom: 0;
        right: -25px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 25px 0 25px 25px;
        border-color: transparent transparent transparent #EBEBEB;
        z-index: 10;
    }

    .arrow::before {
        content: '';
        position: absolute;
        bottom: 0;
        right: 200px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 25px 0 25px 25px;
        border-color: transparent transparent transparent #fff;
        background-color: #EBEBEB;
    }
</style>
    